
import httpClient from '../../clients/http/http.client';
import ProfileStats from '../../models/profile-stats/profile-stats.model';
import dateUtil from '../../utils/date/date.util';

const BASE_PATH = '/users/dashboard';

const get = async token => {

  const path = `${ BASE_PATH }`;
  const response = await httpClient.get({ path, token });

  const profileStats = new ProfileStats({
    ...response.data,
    ...response.data.profile,
    activeAds: response.data.ads.actives,
    views: response.data.ads.views.total,
    prints: response.data.ads.prints.total,
    favorites: response.data.ads.favorites.total,
    messages: response.data.ads.messages.total,
    rating: response.data.rating,
    viewsByMonth: response.data.profile.views.monthly.map(({
      month,
      count,
      year,
    }) => ({
      month: dateUtil.numberToMonth({
        number: month,
      }),
      count,
      year,
    })),
  });

  return profileStats;
};

export default {
  get,
};
